
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","clip-path":"url(#clip0_6047_32)"}},[_c('path',{attrs:{"stroke-linejoin":"round","d":"M13.502 8.865V5.497a1.33 1.33 0 0 0-.667-1.153L8.169 1.677a1.33 1.33 0 0 0-1.334 0L2.17 4.344a1.33 1.33 0 0 0-.667 1.153v5.333a1.33 1.33 0 0 0 .667 1.153l4.666 2.667a1.33 1.33 0 0 0 1.334 0"}}),_c('path',{attrs:{"d":"M9.634 10.298a3.552 3.552 0 0 0-5.58 2.772m5.58-5.57a2.157 2.157 0 1 1-4.314 0 2.157 2.157 0 0 1 4.314 0Z"}}),_c('path',{attrs:{"d":"M4.074 12.847a3.55 3.55 0 0 1 5.764-2.4M11.504 10.244v4.5M13.739 12.501h-4.5"}})]),_c('defs',[_c('clipPath',{staticClass:"i-clip0_6047_32"},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h17v17H0z"}})])])])
          )
        }
      }
    